module.exports = __webpack_public_path__ + "img/visual_ID_guidelines_illustration.ab6e803d.svg";